import React from "react";
import Link from "next/link";

type Props = {
    title: React.ReactNode;
    description: string,
    img: string,
    imgAlt: string,
    hasActions?: boolean,
    className?: string
};

const ThankYouSection: React.FC<Props> = ({ title, description, img, imgAlt, hasActions, className }) => {
    return (
        <>
            <section className={`hero-section product-page ${className}`}>
                <div className={'container'}>
                    <div className={"d-flex"}>
                        <div className={"left-block"}>
                            <div className={"hero-child"}>
                                {title}
                                <p>{description}</p>
                               <div className={"d-flex"}>
                                    <Link href={"/"} className={"sign-up ahref-btn primary"}>Go Back Home</Link>
                                </div>
                            </div>
                        </div>
                        <div className={"right-block"}>
                            <img src={img} alt={imgAlt}
                                 width={100}
                                 height={100}/>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ThankYouSection;